import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";
import type { InitializeResponse } from "../types";

export function useInitializePaymentService(
  message: string,
  authenticateUrl: string,
) {
  return useQuery<InitializeResponse>({
    queryKey: ["service-call-initialize", message, authenticateUrl],
    queryFn: async () => {
      const params = Object.fromEntries(
        new URLSearchParams(window.location.search),
      );
      const res = await axiosInstance().post(authenticateUrl, {
        params,
      });
      return res.data?.data;
    },
    staleTime: Infinity,
    retry: false,
  });
}
